export default (theme) => ({
  backdrop: {
    height: '100%',
    width: '100%',
    zIndex: 1000,
    color: theme.palette.background.white,
    borderRadius: 33,
    overflow: 'hidden',
    background: '#3B3B3B',
    position: 'relative',
  },
  webcamVideo: {
    height: '100%',
    width: '100%',
    objectFit: 'contain',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%) scaleX(-1)',
  },
  videoElement: {
    width: '100%',
    height: '100%',
    flexShrink: 1,
    objectFit: 'cover',
  },
  sharingVideoElement: {
    width: '100%',
    height: '100%',
    flexShrink: 1,
    objectFit: 'contain',
  },
  hiddenVideoElement: {
    display: 'none',
  },
  cameraAccessDenied: {
    height: '100%',
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
      minHeight: 300,
    },
    [theme.breakpoints.down('sm')]: {
      minHeight: 200,
    },
  },
  info: {
    width: '90%',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    margin: 'auto',
    '& span': {
      fontWeight: 'bold',
      lineHeight: 1.5,
    },
  },
  videoRoomParticipant: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    backgroundColor: '#585858',
  },
  participantVideoItem: {
    position: 'relative',
    width: '100%',
    height: '100%',
  },
  fullLocalParticipantVideoItem: {
    position: 'relative',
    height: '100%',
    width: '100%',
    '& video': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
  fullLocalSharedParticipantVideoItem: {
    position: 'relative',
    height: '100%',
    width: '100%',
    '& video': {
      width: '100%',
      height: '100%',
      objectFit: 'contain',
    },
  },
  localParticipantVideoItem: {
    height: 130,
    width: 240,
    borderRadius: 20,
    position: 'absolute',
    overflow: 'hidden',
    top: 20,
    right: 20,
    zIndex: 100,
    [theme.breakpoints.down('sm')]: {
      width: 100,
      borderRadius: 10,
    },
  },
  gridParticipantVideoItem: {
    display: 'block',
    flexGrow: 0,
    flexShrink: 1,
    flexBasis: 'auto',
    alignSelf: 'auto',
    order: 0,
    position: 'relative',
    minWidth: '50%',
    width: '50%',
    height: 'auto',
    overflow: 'hidden',
  },
  dominantGridParticipantVideoItem: {
    border: `2px solid ${theme.palette.success.main}`,
  },
  camParticipantName: {
    fontSize: 12,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
  sharingParticipantName: {
    fontSize: 12,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
  camParticipantNameLocal: {
    fontSize: 12,
    paddingLeft: 5,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
  participantName: {
    display: 'inline-flex',
    alignItems: 'baseline',
    maxWidth: '75%',
    overflow: 'hidden',
    width: 'auto',
    position: 'absolute',
    bottom: 10,
    left: 10,
    padding: '3px 8px',
    backgroundColor: `${theme.palette.disabled.main}80`,
    color: theme.palette.background.white,
    borderRadius: 7,
    zIndex: 90,
    fontSize: 12,
    [theme.breakpoints.down('sm')]: {
      bottom: 4,
      left: 4,
    },
  },
  hoveredParticipantName: {
    maxWidth: 'calc(100% - 20px)',
    overflow: 'visible',
    '& span': {
      whiteSpace: 'normal',
    },
  },
  smallParticipantName: {
    bottom: 5,
    left: 5,
    [theme.breakpoints.down('sm')]: {
      bottom: 3,
      left: 3,
    },
  },
  personIcon: {
    minWidth: 24,
    width: 24,
    fill: theme.palette.disabled.main,
    marginRight: 10,
  },
  disabledCamParticipantName: {
    textTransform: 'capitalize',
    paddingRight: 10,
    fontSize: 12,
    [theme.breakpoints.down('sm')]: {
      fontSize: 10,
    },
  },
  disabledCamParticipantNameWrap: {
    width: '80%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    color: theme.palette.background.white,
  },
  netStability: {
    position: 'absolute',
    top: 10,
    right: 10,
    display: 'flex',
    alignItems: 'flex-end',
    width: 15,
    height: 15,
    zIndex: 100,
  },
  stabilityPid: {
    height: 6,
    width: 4,
    backgroundColor: theme.palette.success.main,
    marginRight: 2,
    '&:nth-child(2)': {
      height: 10,
    },
    '&:nth-child(3)': {
      height: 15,
    },
  },
  orangeStabilityPid: {
    backgroundColor: '#FFA500',
  },
  redStabilityPid: {
    backgroundColor: '#FF0000',
  },
  offlineMessageWrapper: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    margin: 'auto',
  },
  offlineMessageIcon: {
    fill: theme.palette.background.default,
    marginRight: 10,
  },
  offlineMessage: {
    color: theme.palette.background.default,
    userSelect: 'none',
  },
  mirrored: {
    transform: 'scaleX(-1)',
  },
  portrait: {
    objectFit: 'contain',
  },
});
